// extracted by mini-css-extract-plugin
export default {"root":"EditListingOfferDescriptionPanel_root__SaKxp","form":"EditListingOfferDescriptionPanel_form__iadxd","title":"EditListingOfferDescriptionPanel_title__gwttz"};